export const SET_COMMUNITIES_CONTEXT = 'communitiesContext/SET';

export const setCommunitiesContext = payload => dispatch => {
  dispatch({ type: SET_COMMUNITIES_CONTEXT, payload });
  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./app/actions/set-communities-context.js